import { RelayReason } from '../types/ports'

const REASON_COLORS: Record<RelayReason, string> = {
  REASON_FORCE: 'white',
  REASON_PRICE: 'primary.main',
  REASON_REALTIME_SELL_AVOIDANCE: 'orange',
  REASON_PREDICTED_SELL_AVOIDANCE: 'brown',
  REASON_FUSE_PROTECTION: 'secondary.main',
  REASON_COMPENSATION_SELL_AVOIDANCE: '#2afeb7',
  REASON_ENION_CLOUD: 'error.light',
  REASON_UTILITY: 'error.dark',
  REASON_END_OF_PREVIOUS_ITEM: '#1faf74',
  REASON_CALENDAR: 'white',
  REASON_TEMPERATURE_LIMIT: 'green',
  REASON_TEMPERATURE_LIMIT_HARD: 'lime',
  REASON_DEFAULT: 'error.light',
  REASON_UNKNOWN: 'grey',
}

const colors = {
  reason: (r: RelayReason) => REASON_COLORS[r]
}

export default colors
